import React, { useEffect, useState } from 'react';
import { Label } from 'reactstrap';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import styled from 'styled-components';
import BackButton from '../../../components/custom/BackButton';
import { createdUpdatedInfo, formatDatetime, formatMawb, getTsDate } from '../../../utils';
import ActionIcon from '../../../components/custom/ActionIcon';
import { AppUnit, IFFM, SelectOption, IUser } from '../../../globals/interfaces';
import useTypedForm from '../../../components/custom/hookForm/useTypedForm';
import Select from 'react-select';
import _ from 'lodash';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import moment from 'moment';
import { HandleUpdate } from '.';

interface Props {
    modal: boolean;
    setModal: (state: boolean) => void;
    item: IFFM | undefined;
    user: IUser;
    handleUpdate: HandleUpdate;
}

export default function ModalManagePerStorage({
    modal,
    setModal,
    item,
    user,
    handleUpdate
}: Props) {

    const {
        formState: {
            errors,
            isValid,
            isDirty
        },
        handleSubmit,
        trigger,
        reset,
        watch,
        setValue,
        FormInput
    } = useTypedForm<IFFM>({
        mode: 'all',
        resolver: yupResolver(yup.object().shape({
            d_storage_first_free: yup.date().required(),
            d_storage_second_free: yup.date().required(),
            d_storage_start: yup.date().required()
        }))
    });

    useEffect(() => {
        if (!item) return;
        const obj = _.cloneDeep(item);
        // @ts-ignore
        obj.d_storage_first_free = deductDay(obj.d_storage_first_free);
        // @ts-ignore
        obj.d_storage_second_free = deductDay(obj.d_storage_second_free);
        // @ts-ignore
        obj.d_storage_start = deductDay(obj.d_storage_start);

        obj.s_modified_by = user.s_email;
        obj.t_modified = getTsDate();
        reset(obj);
        trigger();
    }, [item]);

    const newStorageStart = watch('d_storage_start');
    const lessThanStorageStart = item && moment(newStorageStart).isBefore(moment(item.d_arrival_date));

    const toggle = () => setModal(!modal);

    if (!item) return null;


    return (
        <Modal isOpen={modal} toggle={toggle}>
            <ModalHeader className={'d-flex'}>
                <HeaderContainer>
                    <BackButton onClick={toggle} />
                    <h4 className={'pl-2'}>Flight: {item.s_flight_id} Manage Dates</h4>
                </HeaderContainer>
            </ModalHeader>
            {
                lessThanStorageStart && item ? (
                    <ModalBody>
                            <h1>Cannot deduct further. Arrival is {formatDatetime(item.d_arrival_date, true)}</h1>
                    </ModalBody>
                ) : (
                    <>
                        <ModalBody>
                            <h1>Are you sure you want to deduct 1 free day for awb {formatMawb(item.s_mawb)}?</h1>
                        </ModalBody>
                        <ExpandedFooter>
                            <FooterContentContainer>
                                <FooterButtonsContainer update>
                                    <ActionIcon
                                        type={'cancel'}
                                        onClick={toggle}
                                    />
                                    <ActionIcon
                                        type={'check'}
                                        onClick={handleSubmit(handleUpdate)}
                                        disabled={!isValid}
                                    />
                                </FooterButtonsContainer>
                            </FooterContentContainer>
                        </ExpandedFooter>
                    </>
                )
            }

        </Modal>
    );
}

const deductDay = (date: Date) => {
    return moment.utc(date).subtract(1, 'day').format('YYYY-MM-DD');
}

const HeaderContainer = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
`;

const ExpandedFooter = styled(ModalFooter)`
    width: 100%;
`;

const FooterContentContainer = styled.div`
    width: 100%;
`;

const FooterButtonsContainer = styled.div<{ update?: boolean }>`
    width: 100%;
    display: flex;
    justify-content: ${p => p.update ? 'space-between' : 'flex-end'};
`;